<template>
  <div class="dipers-size">
    <!-- <form-select
      :data="optionData" :label="'Quantidade de fraldas/mês'"
      @change-data="checkSelectedOption($event)"
    /> -->
    <form-select
      :data="typeData"
      :label="'Tipos de fralda'"
      @change-data="typeSelectedOption($event)"
      v-model="type"
    />
    <form-select
      :data="sizeData"
      :label="'Tamanho da fralda'"
      @change-data="sizeSelectedOption($event)"
      v-model="size"
    />
    <div class="block">
      <h2 class="label">
        Atendendo as orientações da Resolução CFM n. 1658/2002 do Conselho
        Federal de Medicina, escolha a opção de sua preferência
      </h2>
      <b-field>
        <b-radio
          name="name"
          @input="$emit('input-radio')"
          native-value="false"
          v-model="radioChecked"
        >
          Não - Não autorizo a inclusão do meu diagnóstico (CID) no documento
          solicitado
        </b-radio>
      </b-field>
      <b-field>
        <b-radio
          name="name"
          @input="$emit('input-radio')"
          native-value="true"
          v-model="radioChecked"
        >
          Sim - Autorizo a inclusão do meu diagnóstico (CID) no documento
          solicitado
        </b-radio>
      </b-field>
    </div>
  </div>
</template>

<script>
import FormSelect from '@/components/atestados/FormSelect'
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'DiapersSize',
  data() {
    return {
      radioChecked: '',
      size: 'Escolha uma opção...',
      qnt: 'Escolha uma opção...',
      type: 'Escolha uma opção...',
      typeSelected: '',
      sizeSelected: ''
    }
  },
  components: {
    FormSelect
  },
  updated() {
    this.handleData()
  },
  computed: {
    ...mapGetters({
      getCombosResponse: 'getCombosResponse'
    }),
    toBoolean() {
      let realBolean = true
      this.radioChecked === 'true' ? (realBolean = true) : (realBolean = false)
      return realBolean
    },
    sizeData() {
      return Object.entries(this.getCombosResponse.TamanhosFralda).map(
        ([key, value]) => {
          const dataSize = {
            key: key,
            value: value
          }
          return dataSize
        }
      )
    },
    typeData() {
      return Object.entries(this.getCombosResponse.TiposFralda).map(
        ([key, value]) => {
          const typeSize = {
            key: key,
            value: value
          }
          return typeSize
        }
      )
    },
    fullAnswer() {
      const fullAnswer = {
        size: this.sizeSelected,
        type: this.typeSelected,
        cid: this.toBoolean
      }
      return fullAnswer
    }
  },
  methods: {
    ...mapMutations(['SET_ATESTADO_DADOS', 'DESABILITAR_BOTAO_ENVIAR']),
    handleData() {
      this.DESABILITAR_BOTAO_ENVIAR(
        !(this.radioChecked && this.sizeSelected && this.radioChecked)
      )
      this.SET_ATESTADO_DADOS(this.fullAnswer)
    },
    typeSelectedOption(obj) {
      this.typeSelected = obj.value
    },
    sizeSelectedOption(obj) {
      this.sizeSelected = obj.value
    }
  }
}
</script>

<style lang="scss" scoped>
.select-form {
  margin-bottom: 2rem;
}
.form-template.general-forms .dipers-size {
  h2.label {
    font-size: 1rem;
    margin-bottom: 0.75rem;
  }
}
</style>
